import { useState, useEffect } from 'react';

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    // Deprecated 'addListener' for 'addEventListener' for broader browser support.
    try {
      media.addEventListener('change', listener);
    } catch (e) {
      media.addListener(listener);
    }

    // Initial check
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    return () => {
      try {
        media.removeEventListener('change', listener);
      } catch (e) {
        media.removeListener(listener);
      }
    };
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
